<template>
  <div>
    <v-list>
      <v-list-item>
        <v-list-item-avatar> </v-list-item-avatar>
      </v-list-item>
      <v-list-item link>
        <v-list-item-content>
          <v-list-item-title class="text-h6"> CNSR </v-list-item-title>
          <v-list-item-subtitle>ESSALUD</v-list-item-subtitle>
          <v-list-item-subtitle></v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-action>
          <v-icon>mdi-menu-down</v-icon>
        </v-list-item-action>
      </v-list-item>
    </v-list>
    <v-divider></v-divider>
    <div class="container-select-items" style="padding: 0 !important;">
      <v-list style="padding: 0;">
        <v-list-group v-model="grupModel" no-action>
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>Por ubicación geo:</v-list-item-title>
              <div style="font-size: .7rem;">Se atiente o vive en</div>
            </v-list-item-content>
          </template>
          <v-list-item>
            <v-list-item-content>
              <v-autocomplete v-model="selectedDepartamento" :items="arrayDepartamentos" label="Departamento"
                @change="loadProvincias" style="padding: 0;margin: 0" outlined dense></v-autocomplete>
              <v-autocomplete v-model="selectedProvincia" :items="arrayProvincias" label="Provincia"
                @change="loadDistritos" style="padding: 0;margin: 0" outlined dense></v-autocomplete>
              <v-autocomplete v-model="selectedDistrito" :items="arrayDistritos" item-text="distrito"
                item-value="ubigeo_reniec" label="Distritos" style="padding: 0;margin: 0" outlined dense
                multiple></v-autocomplete>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>

        <v-list-group v-model="grupModel2" no-action>
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>Por ipress:</v-list-item-title>
            </v-list-item-content>
          </template>
          <v-list-item>
            <v-list-item-content>
              <v-select class="white-color" v-model="selectedZona" :items="arrayZonas" label="Zona" item-text="zona"
                item-value="id_zona" @change="loadClinica" style="padding: 0;margin: 0" outlined dense></v-select>
        <!-- <v-autocomplete v-model="selectedClinica" :items="arrayClinicas" label="Clínicas" item-text="descripCas"
                item-value="id_cas" style="padding: 0;margin: 0;" outlined dense></v-autocomplete> -->
              <v-autocomplete v-model="selectedClinicasTotales" :items="arrayClinicas" outlined dense chips small-chips
                item-text="descripCas" item-value="id_cas" label="Clínicas multiple" multiple
                @change="loadFiltroMultiple" class="autocomplete-scroll"></v-autocomplete>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>

        <v-list-group v-model="grupModel3" no-action>
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>Por paciente:</v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item>
            <v-list-item-content>
              <v-autocomplete v-model="selectedPacienteTotales" :items="arrayPacientesTotales" outlined dense chips
                small-chips item-text="paciente" item-value="num_doc" label="Pacientes multiple" multiple>
              </v-autocomplete>
              <v-autocomplete v-model="selectedPacienteTotales" label="DNI multiple" :items="arrayPacientesTotales"
                item-text="num_doc" item-value="num_doc" style="padding: 0;margin: 0" outlined dense multiple>
              </v-autocomplete>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
      </v-list>
      <div style="padding: 1rem 1rem 0 1rem !important;">
        <v-text-field v-model="selectedPacientes" label="Total pacientes" disabled outlined dense></v-text-field>
        <v-text-field v-model="selectedPacSearch.length" label="Pacientes seleccionados" outlined disabled
          dense></v-text-field>
        <div style="display: flex; justify-content: space-between; margin-bottom: 1rem;">
          <v-btn color="#1973a5" style="background: white !important;max-width: 6.5rem;" text outlined
            @click="searchCoordenadas"> Buscar
          </v-btn>
          <!-- <v-btn color="#1973a5" style="background: white !important; margin-left: .5rem;max-width: 6.5rem;" text
            outlined @click="loadSeleccion">
            Selección </v-btn> -->
          <v-btn color="#1973a5" style="background: white !important;margin-right: .5rem; max-width: 6.5rem;" text
            outlined @click="exportToExcel">
            Exportar
          </v-btn>
        </div>
        <div style="margin-top: .5rem !important; display: flex; justify-content: space-between;">
          <v-btn color="#1973a5" style="background: white !important;max-width: 6.5rem;" text outlined
            @click="clearFiltros">
            Limpiar
          </v-btn>
          <!-- <v-switch color="white" v-model="viewSelect" :label="`Selección`" @click="loadSeleccion"></v-switch> -->
        </div>
      </div>
      <!-- <div style="padding: 0 1rem 1rem 1rem !important;">
        <div style="display: flex;    justify-content: space-between;margin-bottom: 1rem;">
          <v-switch color="white" v-model="viewPaciente" :label="`Paciente`" @click="updatePaciente"></v-switch>
          <v-switch color="white" v-model="viewClinica" :label="`Clínica`" @click="updateClinica"></v-switch>
        </div>
      </div> -->
    </div>
    <v-dialog v-model="dialogLoader" persistent width="300"
        style="padding: 1rem;overflow: hidden !important;background: white !important;">
        <v-progress-circular :size="80" color="primary" :width="5" indeterminate></v-progress-circular>
      </v-dialog>
  </div>
</template>

<style scoped>
::v-deep .v-application .primary--text {
  color: #141414 !important;
  caret-color: #515151 !important;
}

.v-application .primary--text {
  color: #141414 !important;
  caret-color: #515151 !important;
}

::v-deep .v-application .white--text {
  color: rgb(255, 255, 255) !important;
  caret-color: rgba(255, 255, 255, 0.6) !important;
}

.v-input--selection-controls {
  margin-top: 0 !important;
  padding-top: 4px;
}

::v-deep .v-label.v-label--active.theme--light.primary--text {
  top: 2px !important;
}

::v-deep .v-label.v-label--active.theme--light {
  top: 2px !important;
}

::v-deep .v-select.v-select--chips:not(.v-text-field--single-line).v-text-field--box.v-select--chips--small.v-input--dense .v-select__selections,
::v-deep .v-select.v-select--chips:not(.v-text-field--single-line).v-text-field--enclosed.v-select--chips--small.v-input--dense .v-select__selections {
  max-height: 60px !important;
  overflow-y: scroll !important;
}

.theme--light.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled) {
  color: rgb(255, 255, 255) !important;
}

::v-deep .v-text-field.v-text-field--enclosed .v-text-field__details {
  padding-top: 0px;
  margin-bottom: 0px !important;
}

::v-deep .v-application--is-ltr.v-list-group--no-action .v-list-group__items .v-list-item {
  padding-left: 12px !important;
}

.v-application--is-ltr .v-list-group--no-action>.v-list-group__items>.v-list-item {
  padding-left: 12px !important;
}

::v-deep .container-select-items[data-v-7ea7f777] {
  padding: 1rem !important;
}

::v-deep .theme--light.v-list-item .v-list-item__subtitle,
.theme--light.v-list-item .v-list-item__action-text {
  color: rgb(255 255 255 / 100%) !important;
}

.theme--light.v-select .v-select__selections {
  color: rgb(255 255 255 / 100%) !important;
  min-height: 10px;
}

::v-deep .theme--light.v-input input,
.theme--light.v-input textarea {
  color: rgba(255, 255, 255, 1) !important;
}

::v-deep .theme--light.v-label {
  color: rgba(255, 255, 255, 1) !important;
}

::v-deep .theme--light.v-icon {
  color: rgba(255, 255, 255, 1) !important;
}

::v-deep .v-simple-checkbox .v-input--selection-controls__input i {
  color: rgb(88, 88, 88) !important;
}

::v-deep .theme--light.v-text-field--outlined:not(.v-input--is-focused):not(.v-input--has-state)>.v-input__control>.v-input__slot fieldset {
  color: rgb(255, 255, 255);
}

::v-deep .theme--light.v-text-field--outlined:not(.v-input--is-focused):not(.v-input--has-state)>.v-input__control>.v-input__slot fieldset {
  color: rgb(255, 255, 255);
}

.container-select-items {
  padding: 1rem;
}

.v-list-item--link:before {
  background: transparent !important;
}

.router-link-exact-active.router-link-active .v-list-item--active {
  background-color: #ffffff3b;
  color: #ffffff;
  font-weight: 400 !important;
}

.v-list-group div,
.v-list-item-navbar.v-list-item {
  color: #ffffff !important;
  font-weight: 400 !important;
}

.v-list-item-navbar {
  transition: background-color 0.3s, color 0.3s;
}

.v-list-item__title {
  text-align: left;
  font-weight: 400 !important;
}

.v-list-item__icon .v-icon.notranslate.mdi.mdi-folder.theme--light,
.v-list-item__icon .v-icon.notranslate.mdi.mdi-folder.theme--light,
.v-list-item__icon.v-list-group__header__prepend-icon .v-icon {
  color: white !important;
}

.v-list-group {
  color: white !important;
}

.v-list-item-navbar:hover {
  background-color: #ffffff10;
}
::v-deep .v-dialog {
  display: flex;
  justify-content: center;
  box-shadow: none;
  overflow-y: hidden !important;
}
</style>
<script>
import Swal from "sweetalert2";
import { mapState, mapGetters } from "vuex";
import axios from "axios";

export const VUE_APP_API = process.env.VUE_APP_API;
export const VUE_APP_USERNAME = process.env.VUE_APP_USERNAME;
export const VUE_APP_PASSWORD = process.env.VUE_APP_PASSWORD;
import { mapActions } from 'vuex';
export default {
  name: "navBarV",
  props: ["selectedItemBar"],
  data() {
    return {
      selectedClinicasTotales: [],
      viewSelect: false,
      viewPaciente: true,
      viewClinica: true,
      contador: 0,
      grupModel3: false,
      grupModel2: false,
      grupModel: false,
      statusSelect: false,
      dialogLoader: false,
      selectedPacientes: null,
      selectedDepartamento: null,
      selectedProvincia: null,
      selectedDistrito: null,
      selectedPacienteTotales: [],
      selectedPacienteTotalesMultiples: [],
      arrayClinicas: [],
      arrayPacientesTotales: [],
      arrayZonas: [],
      arrayDepartamentos: [],
      arrayProvincias: [],
      arrayDistritos: [],
      arrayPacientes: [],
      selectedPaciente: null,
      selectedClinica: null,
      selectedZona: "Todas",
      openGroups: [],
      datosTotales: [],
      datosExportar: [],
      status: false,
      idDistrito: null,
      selectedItem: null,
      itemModalidad: null,
      itemPeriodo: null,
      ubigeoArray: [],
      itemsNavBar: [
        { text: "Inicio", icon: "mdi-folder", route: "/go/inicio" },
        { text: "Registros", icon: "mdi-folder", route: "/go/registros" },
        {
          text: "Administración",
          icon: "mdi-folder",
          route: "",
          children: [
            { text: "IPRESS", icon: "mdi-folder", route: "/go/ipress" },
            { text: "Pacientes", icon: "mdi-folder", route: "/go/pacientes" },
            { text: "Perfiles", icon: "mdi-folder", route: "/go/perfiles" },
            { text: "Usuarios", icon: "mdi-folder", route: "/go/usuarios" },
            { text: "Asignación", icon: "mdi-folder", route: "/go/asignacion" },
            {
              text: "Carga masiva",
              icon: "mdi-folder",
              route: "/go/carga-masiva-pacientes",
            },
          ],
        },
        {
          text: "Gestión",
          icon: "mdi-folder",
          route: "",
          children: [
            { text: "Pre carga", icon: "mdi-folder", route: "/go/pre-carga" },
            { text: "Cerrar mes", icon: "mdi-folder", route: "/go/cerrar-mes" },
            { text: "Abrir mes", icon: "mdi-folder", route: "/go/abrir-mes" },
          ],
        },
        { text: "Estadística", icon: "mdi-folder", route: "/go/estadistica" },
      ],
      arrayData: [],
    };
  },
  watch: {
    $route() {
      // Fuerza la actualización del componente cuando la ruta cambia
      this.$forceUpdate();
    },
  },
  computed: {
    ...mapGetters(['obtenerDatos']),
    ...mapState({
      activeRoute: (state) => state.activeRoute,
    }),
    selectedPacSearch() {
      return this.obtenerDatos;
    }
  },
  methods: {
    ...mapActions(['setArrayData', 'selectedPacienteSearch', 'getStatusSelect', 'setArrayDataClinica', 'setArrayDataClinicaTotal', 'setViewPaciente', 'setViewClinica']),
    updatePaciente() {
      this.setViewPaciente(this.viewPaciente);
    },
    updateClinica() {
      this.setViewClinica(this.viewClinica);
    },
    clearFiltros() {
      this.selectedDepartamento = null;
      this.selectedProvincia = null;
      this.selectedDistrito = null;
      this.selectedZona = null;
      this.selectedClinica = null;
      this.selectedPacienteTotales = null;
      this.selectedClinicasTotales = null;
      this.selectedPaciente = null;
      this.idDistrito = null;
    },
    loadFiltroMultiple() {
      const array = [];
      /* for (let index = 0; index < this.selectedPacienteTotales.length; index++) {
        const element = this.selectedPacienteTotales[index];
        console.log(element)
        let variable = this.arrayPacientesTotales.filter((e) => e.num_doc == element)
        array.push(...variable)

      }
      this.selectedPacienteTotalesMultiples = array;
      this.setArrayData(array); */
    },
    loadSeleccion() {
      /* this.viewSelect = !this.viewSelect; */
      this.getStatusSelect();
    },
    exportToExcel() {
      // Datos que deseas exportar
      const XLSXStyle = require("xlsx-js-style");

      // Definir cabecera
      const headers = [
        "ID Paciente", "Número de Documento", "Apellido Paterno", "Apellido Materno",
        "Coordenada Paciente", "Descripción Caso", "Dirección", "Distrito Clínica",
        "Distrito Paciente", "Frecuencia", "ID Clínica", "Latitud", "Longitud",
        "Nombres", "Paciente", "Referencia", "Teléfono", "Teléfono Alterno", "Turno"
      ];
      // Convertir datos a formato adecuado para la hoja de cálculo
      const datos = this.selectedPacSearch;
      const rows = datos.map(item => [
        item.idpaciente, item.num_doc, item.ape_pat, item.ape_mat,
        item.cordepac, item.descripcas, item.direccion, item.distritoclinica,
        item.distritopaciente, item.frecuencia, item.idclinica, item.latitud,
        item.longitud, item.nombres, item.paciente, item.referencia,
        item.telefono, item.telefono_alterno, item.turno
      ]);

      // Combinar cabecera y datos
      const worksheetData = [headers, ...rows];

      // Crear una hoja de cálculo
      const worksheet = XLSXStyle.utils.aoa_to_sheet(worksheetData);
      const workbook = XLSXStyle.utils.book_new();
      XLSXStyle.utils.book_append_sheet(workbook, worksheet, 'Pacientes');

      // Exportar a archivo Excel
      XLSXStyle.writeFile(workbook, 'pacientes.xlsx');

    },
    loadZonas() {
      axios.post(VUE_APP_API + "/api/token/", {
        username: VUE_APP_USERNAME,
        password: VUE_APP_PASSWORD,
      }).then((response) => {
        this.auth = "Bearer " + response.data.access;
        axios.post(VUE_APP_API + "/generar_lista_zona/", {}, {
          headers: { Authorization: this.auth },
        }).then((res) => {
          this.arrayZonas = res.data;
        })
      }).catch((response) => {
        response === 404
          ? console.warn("Lo siento, no tenemos servicios")
          : console.warn("Error: ", response);
      });
    },
    loadClinica() {
      this.dialogLoader=true;
      axios.post(VUE_APP_API + "/api/token/", {
        username: VUE_APP_USERNAME,
        password: VUE_APP_PASSWORD,
      }).then((response) => {
        this.auth = "Bearer " + response.data.access;
        axios.post(VUE_APP_API + "/generar_lista_ipress/", { tipoCas: this.selectedZona }, {
          headers: { Authorization: this.auth },
        }).then((res) => {
          this.dialogLoader=false;
          this.arrayClinicas = res.data;
        })
      }).catch((response) => {
        this.dialogLoader=false;
        response === 404
          ? console.warn("Lo siento, no tenemos servicios")
          : console.warn("Error: ", response);
      });
    },
    loadProvincias() {
      this.arrayDistritos = [];
      this.ubigeoArray = [];
      const provincias = this.datosTotales.filter((e) => e.departamento == this.selectedDepartamento)
      const provinciasUnicas = Array.from(new Set(provincias.map(item => item.provincia)));
      this.arrayProvincias = provinciasUnicas;
    },
    loadDistritos() {
      this.selectedDistrito = null;
      const distritos = this.datosTotales.filter((e) => e.provincia == this.selectedProvincia)
      this.arrayDistritos = distritos;
      const distritosUnicos = Array.from(new Set(distritos.map(item => item.distrito)));
      this.ubigeoArray = [];
    },
    loadDepartamento() {
      axios.post(VUE_APP_API + "/api/token/", {
        username: VUE_APP_USERNAME,
        password: VUE_APP_PASSWORD,
      }).then((response) => {
        this.auth = "Bearer " + response.data.access;
        axios.post(VUE_APP_API + "/generar_lista_distrito/", {}, {
          headers: { Authorization: this.auth },
        }).then((res) => {
          this.datosTotales = res.data;
          const departamentosUnicos = Array.from(new Set(this.datosTotales.map(item => item.departamento)));
          this.arrayDepartamentos = departamentosUnicos;
        })
      }).catch((response) => {
        response === 404
          ? console.warn("Lo siento, no tenemos servicios")
          : console.warn("Error: ", response);
      });
    },
    loadPacientes() {
      this.dialogLoader=true;
      axios.post(VUE_APP_API + "/api/token/", {
        username: VUE_APP_USERNAME,
        password: VUE_APP_PASSWORD,
      }).then((response) => {
        this.auth = "Bearer " + response.data.access;
        axios.post(VUE_APP_API + "/generar_lista_paciente/", {}, {
          headers: { Authorization: this.auth },
        }).then((res) => {
          this.arrayPacientes = res.data;
          this.dialogLoader=false;
        })
      }).catch((response) => {
        this.dialogLoader=false;
        response === 404
          ? console.warn("Lo siento, no tenemos servicios")
          : console.warn("Error: ", response);
      });
    },
    searchCoordenadas() {
      this.searchCoordenadasClinicas();
      this.dialogLoader = true;
      axios.post(VUE_APP_API + "/api/token/", {
        username: VUE_APP_USERNAME,
        password: VUE_APP_PASSWORD,
      }).then((response) => {
        this.auth = "Bearer " + response.data.access;
        axios.post(VUE_APP_API + "/generar_lista_geolocalizacion_jaen/",
          {
            ubigeo: this.selectedDistrito,
            clinica: this.selectedClinicasTotales,
            documento: this.selectedPacienteTotales
          }, {
          headers: { Authorization: this.auth },
        }).then((res) => {
          this.dialogLoader = false;
          this.arrayData = res.data;
          this.setArrayData(res.data);
          /* this.searchCoordenadasJaen(); */
          this.selectedPacientes = res.data.length;
        })
      }).catch((response) => {
        this.dialogLoader = false;
        response === 404
          ? console.warn("Lo siento, no tenemos servicios")
          : console.warn("Error: ", response);
      });
    },
    searchCoordenadasJaen() {
      this.searchCoordenadasClinicas();
      this.dialogLoader = true;
      axios.post(VUE_APP_API + "/api/token/", {
        username: VUE_APP_USERNAME,
        password: VUE_APP_PASSWORD,
      }).then((response) => {
        this.auth = "Bearer " + response.data.access;
        axios.post(VUE_APP_API + "/generar_lista_geolocalizacion_jaen/",
          {
            ubigeo: this.selectedDistrito,
            clinica: this.selectedClinicasTotales,
            documento: this.selectedPacienteTotales
          }, {
          headers: { Authorization: this.auth },
        }).then((res) => {
          this.dialogLoader = false;
          /* this.arrayData = res.data; */
          this.arrayData.push(res.data);
          this.setArrayData(this.arrayData);
          this.selectedPacientes = this.arrayData.length;
        })
      }).catch((response) => {
        this.dialogLoader = false;
        response === 404
          ? console.warn("Lo siento, no tenemos servicios")
          : console.warn("Error: ", response);
      });
    },
    searchCoordenadasClinicas() {
      this.dialogLoader = true;
      axios.post(VUE_APP_API + "/api/token/", {
        username: VUE_APP_USERNAME,
        password: VUE_APP_PASSWORD,
      }).then((response) => {
        this.auth = "Bearer " + response.data.access;
        axios.post(VUE_APP_API + "/generar_lista_geolocalizacion_mapa_jaen/",
          {
            ubigeo: this.selectedDistrito,
            clinica: this.selectedClinicasTotales,
            documento: this.selectedPaciente
          }, {
          headers: { Authorization: this.auth },
        }).then((res) => {
          this.dialogLoader = false;
          this.setArrayDataClinica(res.data);
          if (this.contador == 0) {
            this.setArrayDataClinicaTotal(res.data);
            this.contador = 1;
          }
        })
      }).catch((response) => {
        this.dialogLoader = false;
        response === 404
          ? console.warn("Lo siento, no tenemos servicios")
          : console.warn("Error: ", response);
      });
    },
    searchCoordenadasTotales() {
      this.dialogLoader = true;
      axios.post(VUE_APP_API + "/api/token/", {
        username: VUE_APP_USERNAME,
        password: VUE_APP_PASSWORD,
      }).then((response) => {
        this.auth = "Bearer " + response.data.access;
        axios.post(VUE_APP_API + "/generar_lista_geolocalizacion/",
          {
            ubigeo: null,
            clinica: null,
            documento: null
          }, {
          headers: { Authorization: this.auth },
        }).then((res) => {
          this.dialogLoader = false;
          this.arrayPacientesTotales = res.data;
        })
      }).catch((response) => {
        this.dialogLoader = false;
        response === 404
          ? console.warn("Lo siento, no tenemos servicios")
          : console.warn("Error: ", response);
      });
    }
  },
  created() {
    this.loadDepartamento();
    this.loadZonas();
    this.loadPacientes();
    this.searchCoordenadas();
    this.searchCoordenadasTotales();
  },
};
</script>